import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TokenSiteContext } from '../services/TokenSiteContext';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private readonly tokenSiteContext = inject(TokenSiteContext);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!req.url.includes('/token')) {
            return next.handle(req);
        }

        const siteOID = this.tokenSiteContext.siteId;
        const modifiedReq = siteOID ? req.clone({ params: req.params.set('siteOID', siteOID) }) : req;
        return next.handle(modifiedReq).pipe(
            tap((event) => {
                if (
                    siteOID &&
                    event instanceof HttpResponse &&
                    event.body &&
                    typeof event.body === 'object' &&
                    'access_token' in event.body &&
                    typeof event.body.access_token === 'string'
                ) {
                    this.tokenSiteContext.record(event.body.access_token, siteOID);
                }
            }),
        );
    }
}
